export default "__VITE_ASSET__68839b05__"